import React from 'react';
import Icon from '../app_components/Icon';
import { semantic } from '@lexody/design-tokens';

const ICON_COLOR_DEFAULT = semantic.primary.surface.default;
const ICON_COLOR_SELECTED = semantic.primary.surface.darker;

const DASH_ICON_DEFAULT = semantic.greyscale.text.subtitle;

const NAV_ITEMS = [
  { id: 'home', icon: 'estate', href: '/profile/home' },
  { id: 'chat', icon: 'comment', href: '/convos' },
  { id: 'connects', icon: 'users-alt', href: '/connects' },
  { id: 'lex', icon: 'calender', href: '/meetings' },
  { id: 'activities', icon: 'rocket', href: '/exchanges' },
];

const DEFAULT_LABELS = {
  home: 'Home',
  chat: 'Chat',
  connects: 'Connects',
  lex: 'Lex',
  activities: 'Activities',
};

const BottomNav = ({
  activeTab,
  unreadMessages = false,
  unreadLabel = 'New',
  labels = {},
  activitiesHref = '/exchanges',
  variant = 'dash',
}) => {
  const resolvedLabels = { ...DEFAULT_LABELS, ...labels };
  const items = NAV_ITEMS.map((item) =>
    item.id === 'activities' ? { ...item, href: activitiesHref } : item
  );
  const isDash = variant === 'dash';
  const navClass = isDash ? 'foot__section lex-bottom-nav lex-bottom-nav--dash' : 'foot__section lex-bottom-nav';

  return (
    <div className={navClass}>
      <div className="foot__container w-container lex-bottom-nav__inner">
        {items.map((item) => {
          const isActive = activeTab === item.id;
          const showActive = isActive;
          // Dash variant: the icon never changes when selected — the blue
          // circle bubble is the only active indicator.
          const color = isDash
            ? DASH_ICON_DEFAULT
            : (showActive ? ICON_COLOR_SELECTED : ICON_COLOR_DEFAULT);

          return (
            <a
              key={item.id}
              href={item.href}
              className={`lex-bottom-nav__link${showActive ? ' is-active' : ''}`}
              aria-label={resolvedLabels[item.id]}
              aria-current={showActive ? 'page' : undefined}
            >
              <div className="foot__nav-link lex-bottom-nav__item">
                <div className={`lex-bottom-nav__iconBubble${showActive ? ' is-active' : ''}`}>
                  <div className="foot__icon w-embed lex-bottom-nav__icon">
                    {item.id === 'chat' && unreadMessages && (
                      <div className="unread-messages">{unreadLabel}</div>
                    )}
                    <Icon name={item.icon} solid={false} size={isDash ? 22 : 28} color={color} />
                  </div>
                </div>
                {!isDash && (
                  <div
                    className="foot__label lex-bottom-nav__label"
                    style={{ color }}
                  >
                    {resolvedLabels[item.id]}
                  </div>
                )}
              </div>
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNav;
